import { render, staticRenderFns } from "./VendasPorDia.vue?vue&type=template&id=2b576d4e"
import script from "./VendasPorDia.vue?vue&type=script&lang=js"
export * from "./VendasPorDia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports